module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/speakers-adrian-mouat.json
// module id = 435
// module chunks = 14989199539812